import React, {Component} from 'react';
import Select from "react-select";
import {FaPlusCircle} from "react-icons/all";
import {Spinner} from "react-bootstrap";
import InputSpinner from "react-bootstrap-input-spinner";

class CreateOrderVpsComponent extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOs: false,
            isAddon: false,
            isChosseProduct: false,
        }
    }

    changeInput = (event) => {
        let name = event.target.name;
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.props.changeInput(name, value);
    }

    changeQtt = (event) => {
        let value = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
        this.props.changeQtt(value);
    }

    choosseOs = (event) => {
        let name = 'os';
        let value = event.target.value;
        this.props.changeInput(name, value);
    }

    changeAddonCpu = (num) => {
        this.props.changeAddonCpu(num);
    }

    changeAddonRam = (num) => {
        this.props.changeAddonRam(num);
    }

    changeAddonDisk = (num) => {
        this.props.changeAddonDisk(num);
    }

    render() {
        // console.log(this.props.listProduct)
        return (
            <>
                {/*Sản phẩm*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Sản phẩm</div>
                    <div className="col-md-8">
                        <Select
                            options={this.props.listProduct}
                            onChange={ this.props.choosseProduct() }
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder={'Chọn sản phẩm'}
                        />
                    </div>
                </div>
                {/*Addon*/}
                <div className="row form-group mt-4">
                    {
                        this.props.isAddon ? (
                            <>
                                <div className="col-md-3" />
                                <div className="col-md-8">
                                    <button className="btn btn-default" onClick={ () => this.props.btnAddon() }>
                                        <FaPlusCircle /> Thêm cấu hình
                                    </button>
                                </div>
                            </>
                        ) : (
                            <></>
                        )
                    }
                    {
                        this.props.isLoadingAddon ? (
                            <div className="text-center col-md-12">
                                <Spinner animation="grow" variant="primary" />
                                <Spinner animation="grow" variant="secondary" />
                                <Spinner animation="grow" variant="success" />
                                <Spinner animation="grow" variant="danger" />
                                <Spinner animation="grow" variant="warning" />
                                <Spinner animation="grow" variant="info" />
                            </div>
                        ) : (
                            <>
                                {
                                    this.props.isFormAddon ? (
                                        <>
                                            <div className="col-md-3" />
                                            <div className="col-md-8">
                                                <div className="form-group addon-product text-center">
                                                    <label htmlFor="addon" className="text-danger mb-2">Chọn gói Addon</label>
                                                    <div className="row">
                                                        <div className="col-md-4 addon text-center">
                                                            <label>CPU</label>
                                                            {
                                                                Object.keys(this.props.productAddonCpu).length ? (
                                                                    <>
                                                                        <InputSpinner
                                                                            type={'int'}
                                                                            precision={2}
                                                                            max={20}
                                                                            min={0}
                                                                            step={1}
                                                                            value={0}
                                                                            onChange={ (num) =>  this.changeAddonCpu(num) }
                                                                            variant={'dark'}
                                                                            // size="sm"
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </div>
                                                        <div className="col-md-4 addon text-center">
                                                            <label>RAM</label>
                                                            {
                                                                Object.keys(this.props.productAddonRam).length ? (
                                                                    <>
                                                                        <InputSpinner
                                                                            type={'int'}
                                                                            precision={2}
                                                                            max={20}
                                                                            min={0}
                                                                            step={1}
                                                                            value={0}
                                                                            onChange={ (num) =>  this.changeAddonRam(num) }
                                                                            variant={'dark'}
                                                                            // size="sm"
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </div>
                                                        <div className="col-md-4 addon text-center">
                                                            <label>DISK</label>
                                                            {
                                                                Object.keys(this.props.productAddonDisk).length ? (
                                                                    <>
                                                                        <InputSpinner
                                                                            type={'int'}
                                                                            precision={2}
                                                                            max={200}
                                                                            min={0}
                                                                            step={10}
                                                                            value={0}
                                                                            onChange={ (num) =>  this.changeAddonDisk(num) }
                                                                            variant={'dark'}
                                                                            // size="sm"
                                                                        />
                                                                    </>
                                                                ) : (
                                                                    <></>
                                                                )
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </>
                                    ) : (
                                        <></>
                                    )
                                }
                            </>
                        )
                    }
                </div>
                {/*Thời gian thuê*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Thời gian thuê</div>
                    <div className="col-md-8">
                        <Select
                            options={this.props.listBillingCycle}
                            onChange={ this.props.choosseBillingCycle() }
                            className="basic-single"
                            classNamePrefix="select"
                            placeholder={'Chọn thời gian thuê'}
                        />
                    </div>
                </div>
                {/*Số lượng*/}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Số lượng</div>
                    <div className="col-md-8">
                        <input type="number" className="form-control" onChange={ this.changeQtt } value={ this.props.qtt } />
                    </div>
                </div>
                {/*  Hệ điều hành  */}
                <div className="row form-group mt-4">
                    <div className="col-md-3 text-right font-weight-bold">Hệ điều hành</div>
                    <div className="col-md-8">
                        <select name="os" value={ this.props.os } className="form-control" onChange={ this.choosseOs }>
                            <option value="">Chọn hệ đều hành</option>
                            {
                                this.props.listOs.length ? (
                                    this.props.listOs.map( (os, key) => {
                                        return (
                                            <option value={ os.id } key={key}>{ os.os }</option>
                                        )
                                    })
                                ) : (
                                    <></>
                                )
                            }
                        </select>
                    </div>
                </div>
                {/*  Trừ tiền tài khoản  */}
                {
                    this.props.status === 'Finish' ? (
                        <div className="row form-group mt-4">
                            <div className="col-md-3 text-right font-weight-bold">Trừ tiền tài khoản</div>
                            <div className="col-md-8">
                                <input type="checkbox" name="minusCredit" onChange={ this.changeInput } value={ this.props.minusCredit } />
                            </div>
                        </div>
                    ) : (
                        <></>
                    )
                }
            </>
        );
    }
}

export default CreateOrderVpsComponent;